import { NavLink } from 'react-router-dom'
import { faAnglesLeft } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Image } from '@/ui'
import { MobileMenu } from '../MobileMenu'

interface HeaderProps {
  className?: string
  device: string
  handleIconClick: () => void
  isOpen: boolean
}

export const Header = ({
  className,
  device,
  isOpen,
  handleIconClick,
}: HeaderProps) => {
  return (
    <header
      className={`flex items-center justify-between w-full h-12 px-2 ${className}`}
    >
      <div className="flex items-center">
        {isOpen && (
          <NavLink to="/dashboard" className="flex items-center">
            {device === 'desktop' ? (
              <Image
                src="https://heard-images.s3.amazonaws.com/assets/full-heard-logo.svg"
                alt="heard logo"
                height={24}
                className="h-6 w-auto shrink-0"
              />
            ) : (
              <MobileMenu
                onClick={handleIconClick}
                onKeyDown={handleIconClick}
                isOpen={isOpen}
              />
            )}
          </NavLink>
        )}
      </div>

      <Icon
        className="cursor-pointer hover:text-neutral-300 transition-colors"
        color="text-neutral-600"
        icon={faAnglesLeft}
        onClick={handleIconClick}
        size="1x"
      />
    </header>
  )
}
